var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mqtt-charts-mock"},[_c('OfflineChart',{attrs:{"chartData":_vm.mockChartData,"minValueMockData":60,"maxValueMockData":100,"showKalendarButton":false,"navigationItemsToExclude":['live','hour','day'],"chartHeight":700}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }